import React from 'react';
import {
  Dialog,
  DialogContent,
  Button,
  Stack,
  Typography,
} from '@mui/material';
import { Calendar } from 'lucide-mui';
import { useTranslation } from 'react-i18next';
import useLimits from '../../../plan/hooks/limits';
import { initZoomMeetings } from '../../../../services/integrationService';

interface ConnectZoomMeetingsModalProps {
  onClose: () => void;
}

const ConnectZoomMeetingsModal = ({
  onClose,
}: ConnectZoomMeetingsModalProps) => {
  const { t } = useTranslation();
  const guardLimits = useLimits();

  const handleConnectZoomMeetings = async () => {
    guardLimits('meetingBot', async () => {
      const response = await initZoomMeetings();
      window.location.href = response.oauthUrl;
    });
  };

  return (
    <Dialog
      open
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 2,
          maxWidth: 400,
        },
      }}
    >
      <DialogContent>
        <Stack spacing={2} alignItems="center" sx={{ py: 4 }}>
          <Calendar sx={{ width: 48, height: 48, color: 'primary.main' }} />
          <Typography variant="h6">
            {t('settings.meetingBot.zoom.connect')}
          </Typography>
          <Typography variant="body2" color="text.secondary" align="center">
            {t('settings.meetingBot.zoom.allowAccess')}
          </Typography>
          <Button
            onClick={handleConnectZoomMeetings}
            variant="contained"
            startIcon={<Calendar />}
            data-testid="connect-zoom-meetings-button"
          >
            {t('settings.meetingBot.zoom.connectButton')}
          </Button>
        </Stack>
      </DialogContent>
    </Dialog>
  );
};

export default ConnectZoomMeetingsModal;
